import axios from 'axios';
import swal from 'sweetalert'
import Loader from '../loader';
class ApiHelper {
  
  static async request(method, endpoint, params) {
    ApiHelper.applySlient(endpoint);
    let header = ApiHelper.addAuthorizationHeader();
    if (method === ApiHelper.methods.get) {
      return ApiHelper.get(endpoint, params, header);
    } else if (method === ApiHelper.methods.post) {
      return ApiHelper.post(endpoint, params, header);
    } else if (method === ApiHelper.methods.put) {
      return ApiHelper.put(endpoint, params, header);
    } else if (method === ApiHelper.methods.delete) {
      return ApiHelper.delete(endpoint, params, header);
    }
  }

  static async get(endpoint, params, header) {
    Loader.showLoader(true);
    return ApiHelper.instance.get(endpoint, {params:params, headers: header})
    .then((res) => {
      return ApiHelper.verifyResponse(res, ApiHelper.methods.get, endpoint, params)
    })
    .catch((err) => {
      swal("연결오류", '잠시 후 다시 시도해주세요', "error");
    })
    .finally(() => {
      Loader.showLoader(false);
    })
  }

  static async post(endpoint, params, header) {
    Loader.showLoader(true);
    ApiHelper.addHeader(header, 'Content-Type', 'application/json');
    return ApiHelper.instance.post(endpoint, params, {headers: header})
    .then((res) => {
      return ApiHelper.verifyResponse(res, ApiHelper.methods.post, endpoint, params)
    })
    .catch((err) => {
      swal("연결오류", '잠시 후 다시 시도해주세요', "error");
    })
    .finally(() => {
      Loader.showLoader(false);
    })
  }

  static async put(endpoint, params, header) {
    Loader.showLoader(true);
    ApiHelper.addHeader(header, 'Content-Type', 'application/json');
    return ApiHelper.instance.put(endpoint, params, {headers: header})
    .then((res) => {
      return ApiHelper.verifyResponse(res, ApiHelper.methods.put, endpoint, params)
    })
    .catch((err) => {
      swal("연결오류", '잠시 후 다시 시도해주세요', "error");
    })
    .finally(() => {
      Loader.showLoader(false);
    })
  }

  static async delete(endpoint, params, header) {
    Loader.showLoader(true);
    return ApiHelper.instance.delete(endpoint, {params:params, headers: header})
    .then((res) => {
      return ApiHelper.verifyResponse(res, ApiHelper.methods.delete, endpoint, params)
    })
    .catch((err) => {
      swal("연결오류", '잠시 후 다시 시도해주세요', "error");
    })
    .finally(() => {
      Loader.showLoader(false);
    })
  }
  
  static async verifyResponse(res, method, endpoint, params) {
    if(res.data.status === 'AUTHENTICATION_REQUIRED'){
      return swal("로그인", res.data.msg, "error").then(() => {
        window.location = '/admin/login';
      });
    }else if(res.data.status === 'AUTHENTICATION_REQUIRED_MEM'){
     return window.location = '/ezp-2/login?token=null';
    }
    
    else if(res.data.status === 'TOKEN_EXPIRED'){
      // issue new accessToken
      await ApiHelper.issueNewAccessToken();

      // retry
      return ApiHelper.request(method, endpoint, params)
      
    }else if(res.data.status === 'TOKEN_EXPIRED_MEM'){
      // issue new accessToken
      await ApiHelper.issueNewAccessToken2();

      // retry
      return ApiHelper.request(method, endpoint, params)
    }
     else {
      return res;
    }
  }

  static async issueNewAccessToken(){
    let storage =  window.sessionStorage;
    let params = {}
    params.refreshToken = storage.getItem('refreshToken');
    return new Promise((resolve, reject) => {
      ApiHelper.request(ApiHelper.methods.post, '/auth/token/action/issue', params)
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        if(data.status === 'SUCCESS'){
          storage.setItem('accessToken', data.data.accessToken);
          resolve(true)
        } else if(data.status === 'INVALID'){
          swal("로그인", data.msg, "error").then(() => {
            window.location = '/admin/login';
          });
        }
      })
    })
  }
  static async issueNewAccessToken2(){
    let storage =  window.sessionStorage;
    let params = {}
    params.refreshToken = storage.getItem('refreshToken');
    return new Promise((resolve, reject) => {
      ApiHelper.request(ApiHelper.methods.post, '/ezp2/mem/:memNo/login/token/action/issue', params)
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        if(data.status === 'SUCCESS'){
          storage.setItem('accessToken', data.data.accessToken);
          resolve(true)
        } else if(data.status === 'INVALID'){
          return window.location = '/ezp-2/login?token=null';
        }
      })
    })
  }
  
  static addHeader(header, key, value){
    let newheader = header || {};
    newheader[key] = value;
    return newheader;
  }
  
  static addAuthorizationHeader(header){
    let storage =  window.sessionStorage;
    let accessToken = storage.getItem('accessToken');
    return ApiHelper.addHeader(header, 'Authorization', accessToken)
  }
  
  static applySlient(endpoint){
    Loader.setSilent(endpoint.indexOf('code/') > -1 ? true : false);
  }
}

//ApiHelper.baseURL = "http://localhost:3001/";
ApiHelper.baseURL = process.env.REACT_APP_API_HOST;
ApiHelper.instance = axios.create({
  baseURL: ApiHelper.baseURL,
  timeout: 180000,
  withCredentials: false
});

ApiHelper.methods = {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  delete: 'DELETE',
};


export default ApiHelper;
